import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import AnimatedPrice from "@/components/AnimatedPrice";
import { ADD_ONS, CORE_PRICE_CENTS, formatPrice } from "@/lib/personalization";

interface PriceSummaryProps {
  selectedAddons: typeof ADD_ONS;
  totalCents: number;
  loading: boolean;
  onCheckout: () => void;
}

const PriceSummary = ({ selectedAddons, totalCents, loading, onCheckout }: PriceSummaryProps) => {
  return (
    <Card className="border-border">
      <CardContent className="p-6 space-y-4">
        <h3 className="font-display text-lg text-foreground">Your Plan</h3>

        <div className="space-y-3">
          <div className="flex justify-between text-sm">
            <span className="text-foreground">Core Membership</span>
            <span className="text-foreground">
              {formatPrice(CORE_PRICE_CENTS)}
            </span>
          </div>

          {selectedAddons.map((a) => (
            <div key={a.id} className="flex justify-between text-sm">
              <span className="text-muted-foreground">{a.name}</span>
              <span className="text-muted-foreground">
                +{formatPrice(a.priceCents)}
              </span>
            </div>
          ))}
        </div>

        <div className="border-t border-border pt-3 flex justify-between items-baseline">
          <span className="font-display text-foreground">Total</span>
          <AnimatedPrice value={formatPrice(totalCents)} className="font-display text-2xl text-foreground">
            <span className="text-sm text-muted-foreground font-sans">
              /mo
            </span>
          </AnimatedPrice>
        </div>

        <Button
          className="w-full"
          onClick={onCheckout}
          disabled={loading}
        >
          {loading ? "Loading…" : "Continue to Checkout"}
        </Button>

        <p className="text-[11px] text-muted-foreground text-center leading-relaxed">
          Provider determines final treatment eligibility. You can modify
          your plan anytime.
        </p>
      </CardContent>
    </Card>
  );
};

export default PriceSummary;
